import { Component, Input, OnInit } from "@angular/core";
import { Notifier, OfflineReportPreviewService } from "../../../../../_services/offline-report-preview.service";
import { LoginUserOfflineService } from "../../../../../_services/offline/login-user-offline.service";
import { ReportPreviewContentService } from "../../../../../_services/report-preview-content.service";
import { StorageService } from "../../../../../_services/storage.service";
import { ReportText, TextComponent } from "../../../../models/report-preview/report-text";
import { TableData } from "../../../../models/report-preview/TableData";

@Component({
  selector: "app-report-text-container-offline",
  templateUrl: "./report-text.component.html",
  styleUrls: ["./report-text.component.scss"],
  standalone: false
})
export class ReportTextOfflineComponent implements OnInit {
  @Input() public pageKey: string;
  @Input() public textKey: string;
  @Input() public elementLocation: string;
  @Input() public tableData: TableData[];

  public reportText: ReportText;
  public isVisol: boolean;
  private notifier: Notifier;
  private resizeMarkerSize: number;
  private resizing: boolean;
  private oldValidValue: string;
  public text: string;
  public componentBase: TextComponent;

  readonly componentOuterStyle = "position: absolute; overflow: hidden;";
  readonly reportTextStyle = "display: table; max-width: initial; max-height: initial;";
  readonly reportTextInlineStyle = "display: table-cell; white-space: pre-wrap; word-break: normal; overflow: hidden;";

  get verticalTop() {
    return this.reportText && this.reportText.isHorizontal ? this.reportText.top : this.reportText.verticalTop();
  }

  constructor(
    public designService: OfflineReportPreviewService,
    private storageService: StorageService,
    private reportPreviewContentService: ReportPreviewContentService,
    private loginUserService: LoginUserOfflineService
  ) {
    this.resizeMarkerSize = 36;
    this.resizing = false;
  }

  public ngOnInit() {
    this.notifier = {
      componentName: "report-text.component",
      ids: { pageId: this.pageKey, elementId: this.textKey }
    };

    this.reportText = this.designService.getText(this.textKey);
    this.oldValidValue = this.reportText.text;
    this.isVisol = true;
    this.text = this.getText();
  }

  public getResizeMarkerSize(): string {
    return this.resizeMarkerSize + "px";
  }

  public getResizeMarkerLeft(horizontal: string): string {
    switch (horizontal) {
      case "left":
        return (this.resizeMarkerSize / 2) * -1 + "px";
      case "center":
        return this.reportText.getWidthPx() / 2 - this.resizeMarkerSize / 2 + "px";
      case "right":
        return this.reportText.getWidthPx() - this.resizeMarkerSize / 2 + "px";
      default:
        return "";
    }
  }

  public getResizeMarkerTop(vertical: string): string {
    switch (vertical) {
      case "top":
        return (this.resizeMarkerSize / 2) * -1 + "px";
      case "middle":
        return this.reportText.getHeightPx() / 2 - this.resizeMarkerSize / 2 + "px";
      case "bottom":
        return this.reportText.getHeightPx() - this.resizeMarkerSize / 2 + "px";
      default:
        return "";
    }
  }

  public getImageIds() {
    if (!this.tableData) {
      return [];
    }
    const images = [];
    this.tableData.map((table) => {
      images.push(...table.images);
    });
    return images;
  }

  public getText() {
    const type = this.reportText.getTextType();
    let rtnText = "";
    const format = this.reportText.getTextFormat();
    const currentUser = this.reportPreviewContentService.userSchemas.find((u) => u.id === this.loginUserService.loginUser.id);
    const pageNum = this.designService.getPageNum(this.pageKey);
    const pageTotalNum = this.designService.getPageTotalNum();
    const imageIds = this.getImageIds();
    switch (type) {
      case "static":
        rtnText = this.reportText.text;
        break;
      case "dynamic":
        const dynamicId = this.reportText.getTextDynamicId();
        const defaultText = this.reportText.text;
        rtnText = this.reportPreviewContentService.getContent(
          dynamicId,
          defaultText,
          format,
          this.reportPreviewContentService.reportSchema,
          this.reportPreviewContentService.inspectionSchema,
          currentUser,
          this.reportPreviewContentService.userSchemas,
          this.reportPreviewContentService.tenantSchema.name,
          pageNum,
          pageTotalNum,
          imageIds
        );
        break;
      case "dynamic-editable":
        const component = this.reportText.getTextComponent();
        rtnText = this.reportPreviewContentService.getEditableContent(
          component,
          format,
          this.reportPreviewContentService.reportSchema,
          this.reportPreviewContentService.inspectionSchema,
          currentUser,
          this.reportPreviewContentService.userSchemas,
          this.reportPreviewContentService.tenantSchema.name,
          pageNum,
          pageTotalNum
        );
        break;
    }
    return rtnText;
  }
}
